import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import BillOfLading from "@/components/BillOfLading";
import { ArrowLeft } from "lucide-react";

export default function BillOfLadingPage() {
  const [searchParams] = useSearchParams();

  const bookingData = {
    full_name: searchParams.get("name") || "",
    whatsapp_number: searchParams.get("phone") || "",
    housing_address: searchParams.get("from") || "",
    airline: searchParams.get("airline") || "",
    flight_number: searchParams.get("flight") || "",
    travel_date: searchParams.get("date") || "",
    travel_time: searchParams.get("time") || "",
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white py-8 px-4 print:bg-white print:py-0">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6 print:hidden">
          <Link to="/shipping" className="inline-flex items-center text-orange-600 hover:text-orange-700">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Shipping
          </Link>
        </div>
        <BillOfLading bookingData={bookingData} />
      </div>
    </div>
  );
}
